import { useState } from "react";
import { IconChevronDown, IconChevronRight } from "./icons";
import { ProvidersBadge } from "./supported-models";

const FaqItem = ({
  question,
  children,
}: { question: string; children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-gray-200 py-3">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-1 text-left font-semibold text-gray-900"
        aria-expanded={open}
      >
        {open ? (
          <IconChevronDown className="shrink-0" />
        ) : (
          <IconChevronRight className="shrink-0" />
        )}
        <span>{question}</span>
      </button>
      {open && (
        <p className="mt-2 ml-6 text-sm text-gray-600 leading-relaxed">
          {children}
        </p>
      )}
    </div>
  );
};

export const SignupMarketing = () => {
  return (
    <div className="bg-white/90 shadow p-12 lg:block hidden lg:w-[500px] h-fit min-h-screen">
      <div className="text-xl text-black font-bold">
        Secure, compliant infrastructure and AI usage from day one
      </div>
      <div className="text-lg text-gold font-bold pt-5 pb-1">
        Isolated, controlled infrastructure
      </div>
      <p>
        Run workloads in dedicated, shared-nothing AWS environments. Maintain
        full control over networking, IAM, and encryption.
      </p>
      <hr className="mt-5 mb-4" />
      <div className="text-lg text-gold font-bold pb-1">
        Security and compliance by default
      </div>
      <p>
        Enforce fine-grained access controls, meet regulatory requirements, and
        scale without re-architecting or reinventing compliance as you grow.
      </p>
      <hr className="mt-5 mb-4" />
      <div className="text-lg text-gold font-bold pb-1">
        Secure, auditable AI usage
      </div>
      <p>
        Proxy and audit every LLM API call across your team. Enforce access
        controls and usage policies so AI stays compliant by default.
      </p>
      <div className="mt-4">
        <ProvidersBadge />
      </div>
      <div className="mt-8">
        <FaqItem question="What does the trial include?">
          The trial includes a 30-day trial of the Aptible Infrastructure
          platform to deploy secure web apps and databases, plus $100 in LLM
          credits to use with LLM Gateway when you sign up with a business
          email.{" "}
          <a
            href="https://www.aptible.com/docs/reference/pricing#trials"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            See full usage limits here
          </a>
          .
        </FaqItem>
        <FaqItem question="Can I use the LLM Gateway as a standalone product?">
          Yes, LLM Gateway works as a standalone product - no Aptible
          infrastructure plan required. Sign up with a business email and you'll
          get $100 in credits to get started.
        </FaqItem>
      </div>
    </div>
  );
};
